import React from 'react';
import { connect } from 'react-redux';
import { LargeVideo, _mapStateToProps } from 'jitsi/large-video/components/LargeVideo.web';
import SharedVideo from 'jitsi/shared-video/components/web/SharedVideo';
import Whiteboard from 'jitsi/whiteboard/components/web/Whiteboard';
import ScreenSharePlaceholder from 'jitsi/large-video/components/ScreenSharePlaceholder.web';
import Captions from 'jitsi/subtitles/components/web/Captions';
import StageParticipantNameLabel from 'jitsi/display-name/components/web/StageParticipantNameLabel';
export class IISightLargeVideo extends LargeVideo {
    render() {
        const { _displayScreenSharingPlaceholder, _isChatOpen, _noAutoPlayVideo, _showDominantSpeakerBadge, _whiteboardReady } = this.props;
        const style = this._getCustomStyles();
        const className = `videocontainer${_isChatOpen ? ' shift-right' : ''}`;
        return (React.createElement("div", { className: className, id: 'largeVideoContainer', ref: this._containerRef, style: style },
            React.createElement(SharedVideo, null),
            _whiteboardReady && React.createElement(Whiteboard, null),
            React.createElement("div", { id: 'etherpad' }),
            React.createElement("div", { id: 'dominantSpeaker', onTouchEnd: this._onDoubleTap },
                React.createElement("div", { className: 'dynamic-shadow' }),
                React.createElement("div", { id: 'dominantSpeakerAvatarContainer' })),
            React.createElement("div", { id: 'remotePresenceMessage' }),
            React.createElement("span", { id: 'remoteConnectionMessage' }),
            React.createElement("div", { id: 'largeVideoElementsContainer' },
                React.createElement("div", { id: 'largeVideoBackgroundContainer' }),
                _displayScreenSharingPlaceholder ? React.createElement(ScreenSharePlaceholder, null) : React.createElement(React.Fragment, null),
                React.createElement("div", { id: 'largeVideoWrapper', onTouchEnd: this._onDoubleTap, ref: this._wrapperRef, role: 'figure' },
                    React.createElement("video", { autoPlay: !_noAutoPlayVideo, id: 'largeVideo', muted: true, playsInline: true }))),
            interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES
                || React.createElement(Captions, null),
            _showDominantSpeakerBadge && React.createElement(StageParticipantNameLabel, null)));
    }
}
export default connect(_mapStateToProps)(IISightLargeVideo);
